import React from 'react';
import PropTypes from 'prop-types';

/*
  Unfortunately, none of the React components we could work with use something
  as simple as the embed or static API.

  Google restructured their map API ~July 2018 and most React map components
  were written around the same time or before. More recent ones require React 16.6+

  We're just creating a simple embed iframe to highlight a place, all we need.

  To get a placeId, find the name of the location you'd like to highlight, and enter in:

  https://developers.google.com/places/place-id

  -JWA
*/
const CustomizableGoogleMap = ({
  placeId = 'ChIJmTYBS8632YgRAd8n6kWtG-M',
  zoom = 13,
  height = '450',
}) => (
  <iframe
    width="100%"
    height={height}
    title="map"
    frameBorder="0"
    src={`https://www.google.com/maps/embed/v1/place?&q=place_id:${placeId}&zoom=${zoom}&key=AIzaSyDth93VyNEsd7TzLqjtSVYubtejITE2HAM`}
    allowFullScreen
  />
);

CustomizableGoogleMap.propTypes = {
  placeId: PropTypes.string,
  zoom: PropTypes.number,
  height: PropTypes.string,
};

export default CustomizableGoogleMap;
